export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرف التشفير:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لغة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["صباح الخير"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مساء الخير"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مساء الخير"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["طاب مساؤك"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الخروج"])}
}